module.exports = __webpack_public_path__ + "media/Video 146.a6ca19dc.mp4";